import { render, staticRenderFns } from "./SchematicAttrs.vue?vue&type=template&id=cf6fa6b2&scoped=true"
import script from "./SchematicAttrs.vue?vue&type=script&lang=js"
export * from "./SchematicAttrs.vue?vue&type=script&lang=js"
import style0 from "./SchematicAttrs.vue?vue&type=style&index=0&id=cf6fa6b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6fa6b2",
  null
  
)

export default component.exports